"use client";

import * as React from "react";
import { Award, MapPin, ShieldCheck } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { Card } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function MpcGarutPilotProject() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="mpcgarutpilotproject" className="py-16 md:py-24 bg-background">
      <div className="container mx-auto px-4">
        <div ref={ref} className={`max-w-4xl mx-auto transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <Card className="border-t-4 border-t-[var(--pp-red)] shadow-xl overflow-hidden bg-[var(--pp-light-gray)]">
            <div className="px-6 py-10 md:p-14 text-center relative">
              {}
              <div className="absolute inset-0 opacity-[0.03] pointer-events-none flex items-center justify-center overflow-hidden">
                <ShieldCheck className="w-96 h-96 text-[var(--pp-black)]" />
              </div>

              <div className="relative z-10 flex flex-col items-center">
                <Badge className="bg-[var(--pp-gold)] text-[var(--pp-black)] hover:bg-[var(--pp-gold)]/90 text-sm md:text-base px-5 py-2 mb-8 uppercase tracking-wider font-bold border-none shadow-md">
                  <Award className="w-5 h-5 mr-2" />
                  Pilot Project Zona PP Jawa Barat
                </Badge>

                <h2 className="text-4xl md:text-6xl font-bold text-[var(--pp-black)] font-default mb-6 uppercase tracking-tight">
                  MPC GARUT
                </h2>

                <div className="w-24 h-1.5 bg-[var(--pp-red)] mx-auto mb-8 rounded-md"></div>

                <p className="text-lg md:text-xl text-muted-foreground max-w-2xl mx-auto leading-relaxed">
                  Majelis Pimpinan Cabang (MPC) Pemuda Pancasila Kabupaten Garut ditetapkan sebagai percontohan utama dalam implementasi sistem dan tata kelola organisasi modern di wilayah Jawa Barat.
                </p>

                <div className="mt-10 flex items-center justify-center gap-2 text-[var(--pp-red)] font-semibold bg-background px-5 py-2.5 rounded-lg shadow-sm border border-border">
                  <MapPin className="w-5 h-5" />
                  <span>Kabupaten Garut, Jawa Barat</span>
                </div>
              </div>
            </div>
          </Card>
        </div>
      </div>
    </section>;
}